module.exports = __webpack_public_path__ + "static/Josh_1_min-6f469bca70f52f7b281fbb4aee002349.jpg";